import React from "react";
import { useThemeMode } from "hooks/useThemeMode";
import { darkPalette } from "helpers/themeColors";

export const FullTankLabel = () => {
  const { isDark } = useThemeMode();
  return (
    <span style={{ color: isDark ? darkPalette.accent : "#1976d2", fontWeight: 500 }}>
      ⛽ Tanque lleno
    </span>
  );
};
